<template>
    <div>
    <v-card :elevation="0" class="v-sheet theme--light br-0">
        <v-card-title>
            <v-row class="col-md-12">
                <v-col cols="12" sm="12" md="6">
                    Este es el example del crud
                </v-col>

                <v-col cols="12" sm="12" md="6">
                    <v-dialog
                            v-model="dialog"
                            fullscreen
                            hide-overlay
                            transition="dialog-bottom-transition"
                            scrollable
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color=""
                                    dark
                                    class="mb-2 float-right bg-light-blue"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    Crear nueva
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                   {{dialogTitulo}}
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        icon

                                        @click="dialog = false"
                                        class="float-right"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-divider></v-divider>
                            </v-card>
                        </v-dialog>
                </v-col> 
        
            </v-row>
        </v-card-title>
                     
        <v-card-text>
            <v-data-table
                    :headers="headers"
                    :items="personas"
                    item-key="Id"
                    class="elevation-0"
                    :loading="tableLoading"
                    no-data-text="No hay datos para mostrar"
                    hide-default-footer
                    dense
                >
                <template v-slot:item="{ item }">
                     <tr>
                        <td>{{ item.Id }}</td>
                        <td>{{ item.Dpi }}</td>
                        <td>{{ item.Nombre }}</td>
                        <td>
                            <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosPersona(item.Id)">
                                <v-icon left>mdi-pencil</v-icon> Actualizar
                            </v-btn>
                        </td>
                    </tr>
                </template>

            </v-data-table>
        </v-card-text>
    </v-card>
    </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
    name: "crud-example",
    components: {
    
    },
    data(){
        return{
            tableLoading:false,
            dialog: false,
            dialogTitulo: 'Registrar Persona',
            personas: []
        }
    },
    methods:{
        obtenerDatosPersonas(){
            this.tableLoading=true;
            this.personas = 
                        [
                            {
                                Id:1, 
                                Dpi: '1234567890123', 
                                Nombre: 'Pedro Javiar Solorzano', 
                                FechaNac: '21/11/1980'
                            },
                            {
                                Id:2, 
                                Dpi: '1234567890126', 
                                Nombre: 'Maria Salomé Pérez Contreras', 
                                FechaNac: '11/08/1987'
                            }
                        ];
            this.tableLoading=false;

    
            
            
        },
        obtenerDatosPersona(Id){
            this.dialogTitulo='Actualizar datos persona ' +Id;
            this.dialog = true;
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "admin" },
            { title: "Ejemplo Crud" }
        ]);
    },
    created(){
        this.obtenerDatosPersonas();
    },
    computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: false,
                    value: "Id"
                },
                {
                    text: "DPI",
                    value: "Dpi"
                },
                {
                    text: "Nombre",
                    value: "Nombre"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
